import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { hasPermissionAnywhere } from "@/lib/permissions";

export function ProtectedRoute({ children, permission, check }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "checking") {
    return (
      <div className="flex h-screen w-full items-center justify-center text-sm text-muted-foreground" data-testid="auth-checking">
        Loading…
      </div>
    );
  }
  if (auth.status !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Force users with a temp password to change it before doing anything else.
  if (auth.user?.must_change_password && location.pathname !== "/profile") {
    return <Navigate to="/profile" replace />;
  }
  // Routes gate on a permission, never a role name. `hasPermissionAnywhere`
  // rather than a per-dealer check because a route isn't about one dealer
  // yet — the page itself re-checks once it knows which dealer it's showing,
  // and the backend re-checks regardless.
  if (permission && !hasPermissionAnywhere(auth.user, permission)) {
    return <Navigate to="/" replace />;
  }
  // `check` covers the rare gate a single permission can't express.
  if (check && !check(auth.user)) return <Navigate to="/" replace />;
  return children;
}
